import React from 'react';
import { createRoot } from 'react-dom/client';
import Inialize from './Initialize';

createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<Inialize />
	</React.StrictMode>
);
